import { render, staticRenderFns } from "./PlayerMain.vue?vue&type=template&id=182c54d7&scoped=true&"
import script from "./PlayerMain.vue?vue&type=script&lang=js&"
export * from "./PlayerMain.vue?vue&type=script&lang=js&"
import style0 from "./PlayerMain.vue?vue&type=style&index=0&id=182c54d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182c54d7",
  null
  
)

export default component.exports